import React, { FC, memo, useCallback, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid, Typography } from '@mui/material'
import { toast } from 'react-toastify'

import { ClientRiskScoreEnum, KycInternalStatusEnum } from '@sparling/financial-common'
import { useStyles } from '../useStyles'
import { useRefresh, useRest } from '../../../../components/Context'
import { InputSelect } from '../../../../components/InputSelect'
import { Modal } from '../../../../components/Modal'
import { createEnum } from '../../../../utils/createEnum'

interface IUploadFile {
  isOpen: boolean
  modalClose: () => void
  idSf: string
  status: KycInternalStatusEnum | undefined
  riskScore: ClientRiskScoreEnum | undefined
}

type ChangeStatusesForm = {
  status: KycInternalStatusEnum
  riskScore: ClientRiskScoreEnum
}

const ChangeStatuses: FC<IUploadFile> = ({ isOpen, modalClose, idSf, status, riskScore }) => {
  const formMethods = useForm<ChangeStatusesForm>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const classes = useStyles()
  const { rxios } = useRest()
  const { saveIsRefresh } = useRefresh()
  const { handleSubmit, reset } = formMethods

  const onSubmit = useCallback(
    (data: ChangeStatusesForm) => {
      rxios.post(`user/change-statuses/${idSf}`, data).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          if (next.success) {
            toast.success(`Statuses was changed`)
          }
        },
        (error) => {
          toast.error(error.response?.data?.message || error.message)
        },
        () => {
          saveIsRefresh(true)
          modalClose()
        },
      )
    },
    [rxios, idSf, saveIsRefresh, modalClose],
  )

  useEffect(() => {
    if (!isOpen) setTimeout(reset, 300)
  }, [isOpen, reset])

  return (
    <Modal
      title="Edit Internal Status"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      submitTitle={'Save'}
    >
      <FormProvider {...formMethods}>
        <Grid container>
          <Grid item xs={12} className={classes.field}>
            <Typography component="span">User Status: </Typography>
            <InputSelect
              defaultValue={status}
              inputName={'status'}
              width={250}
              mt={25}
              placeholder={'Please Select'}
              enums={createEnum(KycInternalStatusEnum)}
            />
          </Grid>

          <Grid item xs={12} className={classes.field}>
            <Typography component="span">Risk Client: </Typography>
            <InputSelect
              defaultValue={riskScore}
              inputName={'riskScore'}
              width={250}
              placeholder={'Please Select'}
              enums={createEnum(ClientRiskScoreEnum)}
            />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}

export const MemoChangeStatuses = memo(ChangeStatuses)
